import { SitkaModule } from "olio-sitka"
import { put, select, call } from "redux-saga/effects"
import { createOAuthPopupWindow } from "../../util/oauth_utils"
import { makeToast } from "../../util/toast_util"
import { appStrings } from "../../common/strings/app_strings"
import * as client from "../../api/client"
import { sendGraphqlRequest } from "../../api/graphQlClient"
import {
    GET_ZOOM_CONFIG,
    GET_ZOOM_CONFIGS,
} from "../../graphql_queries/zoom_config_queries"

const {
    zoomConfigAdded,
} = appStrings.connectedApps

// todo - these should be in a util; also duplicates google utils
const setPendingConfigTeamId = (configState, teamId) => {
    return { ...configState, pendingConfigTeamId: teamId, selected: null }
}

const ingressNewConfigToState = (oldState, config) => {
    const { sort: oldSort, items } = oldState
    const { id } = config
    const sort = oldSort.indexOf(id) != -1 ? oldSort : [...oldSort, id]
    return {
        ...oldState,
        sort,
        items: { ...items, [id]: { ...config } },
    }
}

const deleteCalendarConfigFromState = (oldState, idToDelete) => {
    const { sort, items } = oldState.sort.reduce((acc, id) => {
        return id === idToDelete
            ? acc
            : { items: { ...acc.items, [id]: { ...oldState.items[id] } }, sort: [...acc.sort, id] }

    }, { items: {}, sort: [] })
    const selected = oldState.selected === idToDelete ? null : oldState.selected
    
    return { ...oldState, sort, items, selected }
}

const setSelectedZoomConfigId = (configState, id) => {
    return {
        ...configState,
        selected: id,
        pendingConfigTeamId: null,
    }
}

const computeZoomConfigState = newConfigData => {
    const defaultState = {
        items: {},
        sort: [],
        selected: null,
        pendingConfigTeamId: null,
        saveInProgress: false,
    }

    return newConfigData.reduce((acc, element) => {
        const { sort, items } = acc
        const newItems = { ...items, [element.id]: element }
        const newSort = [...sort, element.id]
        return { ...acc, sort: newSort, items: newItems }
    }, defaultState)
}

const computeNewZoomConfigState = (oldState, newConfigData) => {
    const { sort, items } = computeZoomConfigState(newConfigData)
    const { selected: oldSelected } = oldState
    const selected = sort.includes(oldSelected) ? oldSelected : null
    return { ...oldState, sort, items, selected }
}

export default class ZoomConfigsModule extends SitkaModule {
    moduleName = "zoomConfigs"
    defaultState = {
        items: {},
        sort: [],
        selected: null,
        pendingConfigTeamId: null,
        saveInProgress: false,
    }

    constructor() {
        super()
        this.updateState = this.updateState.bind(this)
    }

    *handleSelectZoomConfig(id) {
        const state = yield select(this.getCurrentState)

        const newState = setSelectedZoomConfigId(state, id)
        yield call(this.updateState, { ...newState })
    }

    *handleZoomSetPendingConfigTeamId(id) {
        const state = yield select(this.getCurrentState)
        const newState = setPendingConfigTeamId(state, id)

        yield call(this.updateState, { ...newState })
    }

    *handleNewZoomToken(oauthTokenId) {
        const currentState = yield select(this.getCurrentState)
        const { pendingConfigTeamId } = currentState

        // create new zoom config for pending team id
        if (pendingConfigTeamId) {
            // create zoom config with oauth token ID & team ID
            const newConfigMeta = {
                teamId: pendingConfigTeamId,
            }
            try {
                const resp = yield call(
                    client.postZoomConfig,
                    newConfigMeta,
                    oauthTokenId,
                )
                const { id } = resp
                makeToast(zoomConfigAdded, "success")

                // fetch graphql config
                yield SitkaModule.callAsGenerator(
                    this.handleFetchZoomConfigById,
                    id,
                )

                // set selected config
                yield SitkaModule.callAsGenerator(
                    this.handleSelectZoomConfig,
                    id,
                )
            } catch (e) {
                const errorMsg =
                    "Failed to create new zoom config. Please try again"
                yield call(makeToast, errorMsg, "danger")
            }
            return
        }
    }

    *handleFetchZoomConfigById(id) {
        if (!id) {
            return
        }
        try {
            const { zoomConfig: resp } = yield call(
                sendGraphqlRequest,
                GET_ZOOM_CONFIG(id),
            )
            const originalState = yield select(this.getCurrentState)
            if (resp.length > 0) {
                const newConfig = resp[0]
                const newState = ingressNewConfigToState(
                    originalState,
                    newConfig,
                )
                yield call(this.updateState, { ...newState })
            }
        } catch (e) {
            const errorMsg =
                "Something went wrong fetching zoom config: " + id
            yield call(makeToast, errorMsg, "danger")
        }
    }

    *handleFetchZoomConfigs() {
        try {
            const { zoomConfig: resp } = yield call(
                sendGraphqlRequest,
                GET_ZOOM_CONFIGS,
            )
            const originalState = yield select(this.getCurrentState)
            const newState = computeNewZoomConfigState(originalState, resp)
            yield call(this.updateState, { ...newState })
        } catch (e) {
            const errorMsg =
                "Something went wrong fetching zoom configs."
            yield call(makeToast, errorMsg, "danger")
        }
    }

    *handleStartZoomOauth(pendingConfigTeamId) {
        yield SitkaModule.callAsGenerator(
            this.handleZoomSetPendingConfigTeamId,
            pendingConfigTeamId,
        )
        const childWindow = createOAuthPopupWindow()
        const service = "zoom"
        yield call(this.modules.oauth.handleStartOAuth, childWindow, service)
    }

    *handleDeleteZoomConfig(configId) {
        try {
            yield call(
                client.deleteZoomConfig,
                configId,
            )
            const state = yield select(this.getCurrentState)
            const newState = deleteCalendarConfigFromState(state, configId)
            yield call(this.updateState, { ...newState })
            yield call(makeToast, "The Zoom Configuration has been deleted and all related accounts have been disconnected.", "success")
        } catch (e) {
            yield call(makeToast, "Something went deleting Zoom Config. Please try Again.", "danger")
        }
    }

    *updateState(newState) {
        yield put(
            this.setState({
                ...(yield select(this.getCurrentState)),
                ...newState,
            }),
        )
    }

    getCurrentState(state) {
        return state.zoomConfigs
    }

    getAppState(state) {
        return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/zoom_configs.js